import React, { ChangeEvent, FC } from 'react'
import styles from 'styles/components/form.module.scss'
import { Spacer } from 'components/Utility'
import { TextInput } from 'components/Form'
import { FormLabel } from 'components/Label'
import { isNumerics } from 'lib/validator'
import { Caution, ErrorDescription } from 'components/Typography'

type Props = {
  label: string
  handleFirstPostalCode: (event: ChangeEvent<HTMLInputElement>) => void
  handleSecondPostalCode: (event: ChangeEvent<HTMLInputElement>) => void
  firstPostalCode: string
  secondPostalCode: string
}

const PostalCodeForm: FC<Props> = (props) => {
  const { label, handleFirstPostalCode, handleSecondPostalCode, firstPostalCode, secondPostalCode } = props

  return (
    <>
      <FormLabel id={'postal-code'} label={label} required={true} />
      <Spacer size={8} />
      <div className={styles.column_two}>
        <div className={styles.column_two__item}>
          <TextInput
            disabled={false}
            maxLength={3}
            onChange={handleFirstPostalCode}
            placeholder={'000'}
            required={true}
            size={'small'}
            type={'tel'}
            value={firstPostalCode}
          />
        </div>
        <Spacer size={8} />
        <div className={styles.column_two__item}>
          <TextInput
            disabled={false}
            maxLength={4}
            onChange={handleSecondPostalCode}
            placeholder={'0000'}
            required={true}
            size={'small'}
            type={'tel'}
            value={secondPostalCode}
          />
        </div>
      </div>
      <ErrorDescription
        isError={!isNumerics(firstPostalCode) || !isNumerics(secondPostalCode)}
        error={'数字で入力してください'}
      />
    </>
  )
}

export default PostalCodeForm
